import { comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";
import SectionHeading from "./SectionHeading";

const featuredIds = [
  "xinghai-huiying",
  "xindong-bianlidian",
  "changan-shiguanglu",
  "shenyuan-qishi",
  "zhiyu-shitang",
  "miaosheng-guocha",
];

export default function Featured() {
  const featured = featuredIds
    .map((id) => comics.find((c) => c.id === id))
    .filter((c): c is NonNullable<typeof c> => Boolean(c));

  return (
    <section id="featured" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeading
          eyebrow="编辑精选"
          title="本周编辑精选推荐"
          subtitle="由香香漫画编辑部从上千部作品中精挑细选，覆盖热血、恋爱、治愈、奇幻等热门类型，每一部都是值得反复品味的高分好漫画。"
        />
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}